<template>
  <div class="directory-table">
    <DirectoryTableOffices
      :items="items"
      :assets="assets"
      :sort="sort"
      v-if="type === 'alloffices'"
    />

    <DirectoryTableFacultyStaff
      :items="items"
      :assets="assets"
      :sort="sort"
      v-if="type === 'facultystaff'"
    />

    <DirectoryTableClubsOrgs
      :items="items"
      :assets="assets"
      :sort="sort"
      v-if="type === 'clubsorgs'"
    />
  </div>
</template>

<script>
import DirectoryTableOffices from './DirectoryTableOffices'
import DirectoryTableFacultyStaff from './DirectoryTableFacultyStaff'
import DirectoryTableClubsOrgs from './DirectoryTableClubsOrgs'

export default {
  name: 'DirectoryTable',

  props: {
    type: {
      type: String
    },
    sort: {
      type: Array,
      default: () => ['name', 'asc']
    },
    items: {
      type: Array,
      default: () => []
    },
    assets: {
      type: Object,
      default: () => {}
    }
  },

  components: {
    DirectoryTableOffices,
    DirectoryTableFacultyStaff,
    DirectoryTableClubsOrgs
  },

  methods: {
    handleSort(field) {
      const dir = this.sort[1] === 'asc' ? 'desc' : 'asc'

      this.$parent.setSort([field, dir])
    },

    dirClass(field) {
      if (this.sort[0] === field) {
        return this.sort[1]
      }
    },

    parsePhoneNumber(number) {
      return parsePhoneNumber(number)
    }
  }
}
</script>
